(function () {
  'use strict';

  var money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  var tabs = ['products', 'collections', 'pages', 'blog'];
  var pageSize = 24;
  var rememberKey = 'discovery-preview-remember-v1';
  var recentKey = 'discovery-preview-recent-v1';

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = String(text);
    return node;
  }

  function safePath(value) {
    return typeof value === 'string' && /^\/(?:products|collections|pages|blogs)\/[a-z0-9_-]+(?:\/[a-z0-9_-]+)?(?:\?.*)?$/i.test(value) ? value : null;
  }

  function safeImageUrl(value) {
    if (typeof value !== 'string') return null;
    try {
      var url = new URL(value);
      return url.protocol === 'https:' && /(^|\.)shopifycdn\.net$|(^|\.)cdn\.shopify\.com$/.test(url.hostname) ? url.href : null;
    } catch (_) { return null; }
  }

  function safeLink(value) {
    if (typeof value !== 'string') return null;
    if (value.startsWith('/') && !value.startsWith('//') && !value.includes('\\')) return value;
    try {
      var url = new URL(value);
      return url.protocol === 'https:' && !url.username && !url.password ? url.href : null;
    } catch (_) { return null; }
  }

  function deliveryMessage(result, messages) {
    if (!result || result.status === 'unavailable') return null;
    if (result.status === 'sold_out') return { text: messages.soldOut || 'Sold out', tone: 'warn' };
    if (!result.delivery) return { text: messages.awaitingStock || 'Awaiting stock', tone: 'info' };
    var date = new Date(result.delivery + 'T12:00:00Z');
    if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== result.delivery) return null;
    var day = date.getUTCDate();
    var suffix = day % 100 >= 11 && day % 100 <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
    var label = new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'Europe/London' })
      .formatToParts(date).map(function (part) { return part.type === 'day' ? part.value + suffix : part.value; }).join('');
    var template = result.status === 'backorder' ? (messages.backorder || 'Expected by {date}') :
      (messages.getItBy || 'Get it by {date}');
    return { text: template.replaceAll('{date}', label), tone: result.status === 'in_stock' ? 'ok' : 'info' };
  }

  function ensureReviewsWidget() {
    if (typeof window.ratingSnippet === 'function') return Promise.resolve();
    if (window.__discoveryReviewsWidget) return window.__discoveryReviewsWidget;
    window.__discoveryReviewsWidget = new Promise(function (resolve) {
      if (!document.querySelector('link[href="https://widget.reviews.io/rating-snippet/dist.css"]')) {
        var css = element('link'); css.rel = 'stylesheet'; css.href = 'https://widget.reviews.io/rating-snippet/dist.css';
        document.head.appendChild(css);
      }
      var script = document.querySelector('script[src="https://widget.reviews.io/rating-snippet/dist.js"]');
      var created = !script;
      if (!script) { script = element('script'); script.src = 'https://widget.reviews.io/rating-snippet/dist.js'; }
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', resolve, { once: true });
      if (created) document.head.appendChild(script);
      setTimeout(resolve, 5000);
    });
    return window.__discoveryReviewsWidget;
  }

  function swatchColour(value, custom) {
    var colours = {
      black: '#222936', 'gloss black': '#222936', 'ultra gloss black': '#222936',
      'satin black': '#292b31', anthracite: '#41434a', 'gloss anthracite': '#41434a', 'matt anthracite': '#41434a',
      'ultra gloss anthracite': '#41434a', 'jet black': '#16181d', 'piano white': '#f8f8f5',
      white: '#fff', 'gloss white': '#fff', 'ultra gloss white': '#fff',
      grey: '#888b90', gray: '#888b90', 'slate grey': '#626a71', 'dusty grey': '#a3a2a1',
      'driftwood grey': '#85847e', 'basalt gray': '#565b5d', 'basalt grey': '#565b5d', silver: '#bcc3cc',
      blue: '#bfdbfe', 'wild blue': '#60a5fa', navy: '#1e3a5f',
      red: '#fda4af', pink: '#f9a8d4', green: '#86c99b', forest: '#456b51',
      brown: '#a47750', oak: '#bd976b', 'gloss oak': '#bd976b', 'wild oak': '#af865c',
      'light wood': '#d1b796', 'natural wood': '#c9ae86', walnut: '#72513d',
      'driftwood concrete': '#9e9b94', 'carbon oak': '#514b43', 'natural oak': '#c7a77e',
      'tobacco oak': '#8b6546', 'platinum oak': '#b7b4ac',
      'grey oak': '#8f8779', 'oak grey': '#8f8779', 'grey nebraska oak': '#a6a093',
      'natural nebraska oak': '#b99d78', 'hampshire oak': '#ae8b67', 'hunton oak': '#ad8b65',
      'kendal oak': '#bd9872', 'bardolino oak': '#b4926c',
      'pasedena pine': '#c4ab86', pine: '#c4ab86',
      'boston concrete': '#a4a3a0', 'chicago concrete': '#969795', 'brushed limestone': '#c3bdb1',
      'black obsidian smoked oak': '#37342f', 'kansas truffle walnut': '#796652',
      beige: '#d9c5a9', cream: '#f5efdc', 'soft cashmere': '#d9d0c0',
      gold: '#c9a458', clear: '#f4f4f5', snow: '#f8f8f6',
      mystic: '#71777b', urban: '#777b7a',
      'black aquarium and black cabinet': '#222936',
      'white aquarium and white cabinet': '#ffffff',
      'mystic aquarium and mystic cabinet': '#71777b',
      'mystic aquarium and marble cabinet': 'linear-gradient(135deg,#71777b 50%,#e5e1da 50%)',
      'white aquarium and oak cabinet': 'linear-gradient(135deg,#ffffff 50%,#bd976b 50%)',
      'black aquarium and black marble cabinet': 'linear-gradient(135deg,#222936 50%,#4f5054 50%)',
      'mystic aquarium and black marble cabinet': 'linear-gradient(135deg,#71777b 50%,#4f5054 50%)',
      'white aquarium and oasis oak cabinet': 'linear-gradient(135deg,#ffffff 50%,#c3a27d 50%)'
    };
    var name = String(value || '').normalize('NFKC').trim().replace(/\s+/g, ' ').toLowerCase();
    var override = custom && Object.prototype.hasOwnProperty.call(custom, name) ? custom[name] : null;
    if (typeof override === 'string' && /^#[0-9a-f]{6}$/i.test(override)) return override;
    return colours[name] || colours[name.replace(/^(?:ultra |high )?(?:gloss |matt |matte |satin )/, '')] || null;
  }

  function renderSwatches(card, values, custom) {
    if (card.querySelector('.discovery-search__swatches') || values.length < 2) return;
    var row = element('div', 'discovery-search__swatches');
    row.setAttribute('aria-label', 'Available colours');
    values.forEach(function (choice) {
      var path = safePath(choice.url);
      if (!path) return;
      var link = element('a', 'discovery-search__swatch');
      link.href = path; link.title = choice.label; link.setAttribute('aria-label', choice.label);
      if (choice.selected) link.dataset.selected = 'true';
      var colour = swatchColour(choice.label, custom);
      if (colour) link.style.background = colour;
      else {
        link.dataset.unmapped = 'true';
        link.appendChild(element('span', null, choice.label.slice(0, 1).toUpperCase()));
      }
      row.appendChild(link);
    });
    if (row.childElementCount) card.appendChild(row);
  }

  function bannerNode(banner, inline) {
    var imageUrl = safeImageUrl(banner.desktopImage);
    if (!imageUrl) return null;
    var article = element('article', 'discovery-search__banner');
    if (inline) {
      article.classList.add('discovery-search__banner--inline');
      var size = window.DiscoveryBannerSession.gridSize(banner);
      article.style.setProperty('--banner-desktop-columns', size.desktopColumns);
      article.style.setProperty('--banner-tablet-columns', size.tabletColumns);
      article.style.setProperty('--banner-desktop-rows', size.desktopRows);
      article.style.setProperty('--banner-mobile-columns', size.mobileColumns);
      article.style.setProperty('--banner-mobile-rows', size.mobileRows);
      window.DiscoveryBannerSession.applyAppearance(article, banner.style);
    }
    var picture = element('picture', 'discovery-search__banner-media');
    var mobileUrl = safeImageUrl(banner.mobileImage);
    if (mobileUrl) {
      var source = element('source');
      source.media = '(max-width: 749px)'; source.srcset = mobileUrl;
      picture.appendChild(source);
    }
    var image = element('img');
    image.src = imageUrl; image.alt = typeof banner.imageAlt === 'string' ? banner.imageAlt : '';
    image.loading = inline ? 'lazy' : 'eager';
    picture.appendChild(image); article.appendChild(picture);
    var copy = element('div', 'discovery-search__banner-copy');
    if (banner.heading) copy.appendChild(element('h2', null, banner.heading));
    if (banner.body) copy.appendChild(element('p', null, banner.body));
    var href = safeLink(banner.ctaUrl);
    if (href && banner.ctaLabel) {
      var cta = element('a', 'discovery-search__banner-cta', banner.ctaLabel);
      cta.href = href; copy.appendChild(cta);
    }
    if (copy.childNodes.length) article.appendChild(copy);
    return article;
  }

  function init(root) {
    if (root.dataset.discoveryReady === '1') return;
    root.dataset.discoveryReady = '1';
    var filterDisclosure = root.querySelector('.discovery-search__filters details');
    if (filterDisclosure && window.matchMedia) {
      var mobileFilters = window.matchMedia('(max-width: 749px)');
      filterDisclosure.open = !mobileFilters.matches;
      mobileFilters.addEventListener('change', function (event) {
        filterDisclosure.open = !event.matches;
      });
    }
    var apiBase;
    try {
      apiBase = new URL(root.dataset.apiBase);
      if (apiBase.protocol !== 'https:') throw new Error('HTTPS required');
    } catch (_) { return; }
    var productDetails = new Map();
    var customSwatchColours = Object.create(null);
    var query = (root.dataset.query || '').trim();
    var shopName = (root.dataset.shopName || '').trim();
    if (query && shopName) document.title = 'Search for “' + query + '” – ' + shopName;
    var bannerSession = window.DiscoveryBannerSession && window.DiscoveryBannerSession.create(root.dataset.limitBannerRepeats === 'true');
    var remember = root.querySelector('[data-discovery-remember]');
    var recent = root.querySelector('[data-discovery-recent]');
    var recentList = root.querySelector('[data-discovery-recent-list]');
    var recentClear = root.querySelector('[data-discovery-recent-clear]');
    function recentTerms() {
      try {
        var value = JSON.parse(sessionStorage.getItem(recentKey) || '[]');
        return Array.isArray(value) ? value.filter(function (term) { return typeof term === 'string' && term.length <= 120; }).slice(0, 6) : [];
      } catch (_) { return []; }
    }
    function renderRecent() {
      recentList.replaceChildren();
      var terms = remember.checked ? recentTerms() : [];
      recent.hidden = terms.length === 0;
      terms.forEach(function (term) {
        var link = element('a', null, term);
        var destination = new URL('/search', window.location.origin);
        destination.searchParams.set('q', term);
        destination.searchParams.set('view', 'discovery-preview');
        link.href = destination.pathname + destination.search;
        recentList.appendChild(link);
      });
    }
    try {
      remember.checked = sessionStorage.getItem(rememberKey) === '1';
      if (remember.checked && query && query.length <= 120) {
        sessionStorage.setItem(recentKey, JSON.stringify([query].concat(recentTerms().filter(function (term) { return term.toLowerCase() !== query.toLowerCase(); })).slice(0, 6)));
      }
    } catch (_) { remember.checked = false; }
    remember.addEventListener('change', function () {
      try {
        if (remember.checked) {
          sessionStorage.setItem(rememberKey, '1');
          if (query && query.length <= 120) sessionStorage.setItem(recentKey, JSON.stringify([query].concat(recentTerms().filter(function (term) { return term.toLowerCase() !== query.toLowerCase(); })).slice(0, 6)));
        } else {
          sessionStorage.removeItem(rememberKey);
          sessionStorage.removeItem(recentKey);
        }
      } catch (_) { remember.checked = false; }
      renderRecent();
    });
    recentClear.addEventListener('click', function () {
      try { sessionStorage.removeItem(recentKey); } catch (_) { /* Storage may be unavailable. */ }
      renderRecent();
    });
    renderRecent();

    var saved = root.querySelector('[data-discovery-saved]');
    if (saved) {
      var savedEnable = saved.querySelector('[data-discovery-saved-enable]');
      var savedEnabled = saved.querySelector('[data-discovery-saved-enabled]');
      var savedList = saved.querySelector('[data-discovery-saved-list]');
      var savedClear = saved.querySelector('[data-discovery-saved-clear]');
      var savedExport = saved.querySelector('[data-discovery-saved-export]');
      var savedDisable = saved.querySelector('[data-discovery-saved-disable]');
      var savedStatus = saved.querySelector('[data-discovery-saved-status]');
      var savedBusy = false;
      async function preferenceRequest(operation, term) {
        var body = { operation: operation };
        if (term !== undefined) body.query = term;
        var response = await fetch('/apps/charterhouse-discovery/preferences', {
          method: 'POST', credentials: 'same-origin', redirect: 'error', referrerPolicy: 'no-referrer',
          headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
        });
        if (!response.ok) throw new Error('Preference service unavailable');
        var profile = await response.json();
        if (!profile || typeof profile.enabled !== 'boolean' || !Array.isArray(profile.recentSearches)) {
          throw new Error('Invalid preference response');
        }
        return profile;
      }
      function renderSaved(profile) {
        savedEnable.hidden = profile.enabled;
        savedEnabled.hidden = !profile.enabled;
        savedList.replaceChildren();
        (profile.recentSearches || []).filter(function (term) {
          return typeof term === 'string' && term.length > 0 && term.length <= 120;
        }).slice(0, 6).forEach(function (term) {
          var item = element('li');
          var link = element('a', null, term);
          var destination = new URL('/search', window.location.origin);
          destination.searchParams.set('q', term);
          destination.searchParams.set('view', 'discovery-preview');
          link.href = destination.pathname + destination.search;
          var remove = element('button', null, saved.dataset.savedRemoveLabel);
          remove.type = 'button';
          remove.dataset.discoverySavedRemove = term;
          remove.setAttribute('aria-label', saved.dataset.savedRemoveLabel + ' ' + term);
          item.appendChild(link); item.appendChild(remove); savedList.appendChild(item);
        });
        savedClear.disabled = !savedList.childElementCount;
      }
      async function changeSaved(operation, term) {
        if (savedBusy) return;
        savedBusy = true;
        savedStatus.textContent = saved.dataset.savedUpdating;
        saved.querySelectorAll('button').forEach(function (button) { button.disabled = true; });
        try {
          var profile = await preferenceRequest(operation, term);
          renderSaved(profile);
          savedStatus.textContent = saved.dataset.savedRemoved;
        } catch (_) {
          savedStatus.textContent = saved.dataset.savedUnavailable;
        } finally {
          savedBusy = false;
          saved.querySelectorAll('button').forEach(function (button) { button.disabled = false; });
          savedClear.disabled = !savedList.childElementCount;
        }
      }
      savedEnable.addEventListener('click', function () { changeSaved('enable'); });
      savedClear.addEventListener('click', function () { changeSaved('clear_searches'); });
      savedExport.addEventListener('click', async function () {
        if (savedBusy) return;
        savedBusy = true;
        savedStatus.textContent = saved.dataset.savedUpdating;
        saved.querySelectorAll('button').forEach(function (button) { button.disabled = true; });
        try {
          var profile = await preferenceRequest('read');
          renderSaved(profile);
          if (!profile.enabled) throw new Error('Saved searches are disabled');
          var exportData = {
            consentVersion: profile.consentVersion,
            consentedAt: profile.consentedAt,
            expiresAt: profile.expiresAt,
            recentSearches: profile.recentSearches,
            interests: Array.isArray(profile.interests) ? profile.interests : []
          };
          var url = URL.createObjectURL(new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' }));
          var link = element('a');
          link.href = url;
          link.download = 'charterhouse-saved-searches.json';
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
          savedStatus.textContent = saved.dataset.savedExported;
        } catch (_) {
          savedStatus.textContent = saved.dataset.savedUnavailable;
        } finally {
          savedBusy = false;
          saved.querySelectorAll('button').forEach(function (button) { button.disabled = false; });
          savedClear.disabled = !savedList.childElementCount;
        }
      });
      savedDisable.addEventListener('click', function () { changeSaved('disable'); });
      savedList.addEventListener('click', function (event) {
        var button = event.target.closest('[data-discovery-saved-remove]');
        if (button) changeSaved('remove_search', button.dataset.discoverySavedRemove);
      });
      preferenceRequest('read').then(async function (profile) {
        saved.hidden = false;
        renderSaved(profile);
        if (profile.enabled && query && query.length <= 120) await changeSaved('add_search', query);
      }).catch(function () { saved.hidden = true; });
    }

    var requestedTab = new URLSearchParams(window.location.search).get('tab');
    var selectedTab = tabs.includes(requestedTab) ? requestedTab : 'products';
    var state = { vendor: '', productType: '', stock: '', tag: '', filterCollection: '', minPrice: '', maxPrice: '', offset: 0 };
    var requestNumber = 0;
    var activeRequest;
    var priceTimer;
    var grid = root.querySelector('[data-discovery-grid]');
    var count = root.querySelector('[data-discovery-count]');
    var message = root.querySelector('[data-discovery-message]');
    var form = root.querySelector('[data-discovery-filters]');
    var filterPanel = root.querySelector('[data-discovery-filter-panel]');
    var filterToggle = root.querySelector('[data-discovery-filter-toggle]');
    var filtersOpen = false;
    var clear = root.querySelector('[data-discovery-clear]');
    var previous = root.querySelector('[data-discovery-previous]');
    var next = root.querySelector('[data-discovery-next]');
    var page = root.querySelector('[data-discovery-page]');
    var tabButtons = Array.from(root.querySelectorAll('[data-discovery-tab]'));
    var tabPanel = root.querySelector('[role="tabpanel"]');
    var recordedImpressions = new Set();
    var recordedClicks = new Set();
    var recordedCollectionOpens = new Set();
    var recordedSearchTerms = new Set();
    var searchId = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : null;

    function recordSearchClick(target) {
      if (!searchId) return;
      fetch('/apps/charterhouse-discovery/search-products', {
        method: 'POST', credentials: 'same-origin', keepalive: true, redirect: 'error', referrerPolicy: 'no-referrer',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kind: 'search_click', query: query, searchId: searchId, target: target })
      }).catch(function () { /* Analytics must never block shopping. */ });
    }

    function recordSearchTerm(productCount) {
      var term = query.normalize('NFKC').trim().replace(/\s+/g, ' ').toLowerCase();
      if (term.length < 2 || term.length > 80 || recordedSearchTerms.has(term) ||
        !Number.isSafeInteger(productCount) || productCount < 0) return;
      recordedSearchTerms.add(term);
      fetch('/apps/charterhouse-discovery/search-products', {
        method: 'POST', credentials: 'same-origin', keepalive: true, redirect: 'error', referrerPolicy: 'no-referrer',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({ kind: 'search', query: term, productCount: productCount },
          searchId ? { searchId: searchId } : {}))
      }).catch(function () { /* Analytics must never block shopping. */ });
    }

    function recordSearchProducts(kind, productIds) {
      if (!productIds.length) return;
      fetch('/apps/charterhouse-discovery/search-products', {
        method: 'POST', credentials: 'same-origin', keepalive: true, redirect: 'error', referrerPolicy: 'no-referrer',
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ kind: kind, productIds: productIds, query: query })
      }).catch(function () { /* Analytics must never block shopping. */ });
    }

    function recordCollectionOpen(collectionId) {
      fetch('/apps/charterhouse-discovery/collection-engagement', {
        method: 'POST', credentials: 'same-origin', keepalive: true, redirect: 'error', referrerPolicy: 'no-referrer',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kind: 'search_open', collectionId: collectionId })
      }).catch(function () { /* Analytics must never block shopping. */ });
      recordSearchClick('collection');
    }

    function selectTab(tab) {
      selectedTab = tab;
      root.dataset.activeTab = tab;
      state.offset = 0;
      tabButtons.forEach(function (button) {
        var active = button.dataset.discoveryTab === tab;
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
        if (active) tabPanel.setAttribute('aria-labelledby', button.id);
      });
      filterToggle.hidden = tab !== 'products';
      filterPanel.hidden = tab !== 'products' || !filtersOpen;
      filterToggle.setAttribute('aria-expanded', filterPanel.hidden ? 'false' : 'true');
      load();
    }

    function resetPage() { state.offset = 0; load(); }

    function renderFields(view) {
      form.replaceChildren();
      if (!view || !Array.isArray(view.fields)) return;
      view.fields.forEach(function (field) {
        if (!['vendor', 'productType', 'stock', 'tag', 'collection', 'price'].includes(field.source)) return;
        var label = element('label', 'discovery-search__field');
        label.appendChild(element('span', null, field.label));
        if (field.source === 'price') {
          var pair = element('span', 'discovery-search__price');
          ['minPrice', 'maxPrice'].forEach(function (key) {
            var input = element('input');
            input.type = 'number'; input.min = '0'; input.step = '0.01';
            input.name = key; input.inputMode = 'decimal'; input.value = state[key];
            input.placeholder = key === 'minPrice' ? '£ Min' : '£ Max';
            input.setAttribute('aria-label', key === 'minPrice' ? 'Minimum price in pounds' : 'Maximum price in pounds');
            pair.appendChild(input);
          });
          label.appendChild(pair);
        } else {
          var select = element('select');
          var key = field.source === 'collection' ? 'filterCollection' : field.source;
          select.name = key;
          var all = element('option', null, 'All ' + field.label.toLowerCase()); all.value = '';
          select.appendChild(all);
          (field.values || []).forEach(function (value) {
            var option = element('option', null, value.label + ' (' + value.count + ')');
            option.value = value.value; select.appendChild(option);
          });
          if (state[key] && !Array.from(select.options).some(function (option) { return option.value === state[key]; })) {
            var current = element('option', null, state[key]); current.value = state[key]; select.appendChild(current);
          }
          select.value = state[key]; label.appendChild(select);
        }
        form.appendChild(label);
      });
    }

    function renderHits(hits, banners) {
      grid.replaceChildren();
      window.DiscoveryBannerSession.gridTiles(hits.length, banners).forEach(function (tile) {
        if (tile.kind === 'banner') {
          var campaign = bannerNode(tile.item, true);
          if (campaign) { grid.appendChild(campaign); if (bannerSession) bannerSession.record(tile.item); }
          return;
        }
        var hit = hits[tile.index];
        var path = safePath(hit.url);
        if (!path) return;
        var article = element('article', 'discovery-search__card discovery-search__card--' + hit.kind);
        var link = element('a'); link.href = path;
        if (hit.kind === 'products' && /^gid:\/\/shopify\/Product\/[1-9]\d*$/.test(hit.shopifyId)) {
          link.dataset.discoveryProductId = hit.shopifyId;
        }
        if (hit.kind === 'collections' && /^gid:\/\/shopify\/Collection\/[1-9]\d*$/.test(hit.shopifyId)) {
          link.dataset.discoveryCollectionId = hit.shopifyId;
        }
        if (hit.kind === 'blog') link.dataset.discoveryGuide = '1';
        var imageUrl = safeImageUrl(hit.imageUrl);
        if (imageUrl || hit.kind === 'products') {
          var media = element('span', 'discovery-search__media');
          if (imageUrl) {
            var image = element('img'); image.src = imageUrl; image.alt = ''; image.loading = 'lazy';
            media.appendChild(image);
          }
          if (hit.kind === 'products' && /^gid:\/\/shopify\/Product\/[1-9]\d*$/.test(hit.shopifyId)) {
            var badges = element('charterhouse-promotions', 'discovery-search__badges');
            badges.setAttribute('kind', 'badge');
            badges.setAttribute('product-id', hit.shopifyId.replace('gid://shopify/Product/', ''));
            media.appendChild(badges);
          }
          link.appendChild(media);
        }
        link.appendChild(element('h3', null, hit.title));
        article.appendChild(link);
        if (hit.kind === 'products') {
          var handle = /^\/products\/([a-z0-9-]+)/i.exec(path);
          if (handle) {
            article.dataset.productHandle = handle[1];
            var review = element('div', 'discovery-search__review');
            var rating = element('span', 'ruk_rating_snippet discovery-search__rating-snippet');
            rating.dataset.sku = handle[1] + ';' + (typeof hit.shopifyId === 'string' ? hit.shopifyId.replace('gid://shopify/Product/', '') : '');
            review.appendChild(rating); article.appendChild(review);
            var delivery = element('div', 'discovery-search__delivery');
            delivery.hidden = true; article.appendChild(delivery);
          }
          if (hit.price !== null && hit.currency === 'GBP') article.appendChild(element('p', 'discovery-search__product-price', money.format(Number(hit.price))));
          if (Array.isArray(hit.swatches)) renderSwatches(article, hit.swatches.map(function (choice) {
            return { label: String(choice.label || 'View colour'), url: choice.url, imageUrl: choice.imageUrl,
              selected: choice.shopifyId === hit.shopifyId };
          }), customSwatchColours);
        } else if (hit.description) article.appendChild(element('p', null, hit.description));
        grid.appendChild(article);
      });
    }

    async function hydrateProductCards(current) {
      var cards = Array.from(grid.querySelectorAll('.discovery-search__card[data-product-handle]'));
      if (!cards.length) return;
      var details = [];
      var cursor = 0;
      async function worker() {
        while (cursor < cards.length && current === requestNumber) {
          var card = cards[cursor++];
          var handle = card.dataset.productHandle;
          try {
            if (!productDetails.has(handle)) {
              var response = await fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
              if (!response.ok) throw new Error('Product details unavailable');
              productDetails.set(handle, await response.json());
            }
            if (current !== requestNumber || !card.isConnected) return;
            var item = productDetails.get(handle);
            var variants = Array.isArray(item.variants) ? item.variants : [];
            if (!card.querySelector('.discovery-search__swatches')) {
              var options = Array.isArray(item.options) ? item.options : [];
              var colourIndex = options.findIndex(function (option) {
                return /^(colou?r|finish)$/i.test(String(typeof option === 'string' ? option : option && option.name).trim());
              });
              if (colourIndex >= 0) {
                var seen = new Set();
                renderSwatches(card, variants.map(function (variant) {
                  var value = Array.isArray(variant.options) ? variant.options[colourIndex] : variant['option' + (colourIndex + 1)];
                  value = String(value || '').trim();
                  if (!value || seen.has(value.toLowerCase()) || !/^\d+$/.test(String(variant.id))) return null;
                  seen.add(value.toLowerCase());
                  return { label: value, url: '/products/' + encodeURIComponent(handle) + '?variant=' + encodeURIComponent(variant.id),
                    imageUrl: variant.featured_image && variant.featured_image.src, selected: seen.size === 1 };
                }).filter(Boolean), customSwatchColours);
              }
            }
            card.querySelector('.discovery-search__rating-snippet').dataset.sku =
              [item.handle].concat(variants.map(function (variant) { return variant.sku; }).filter(Boolean),
                variants.map(function (variant) { return variant.id; }), item.id).join(';');
            var selected = variants.find(function (variant) { return variant.available; }) || variants[0];
            var price = card.querySelector('.discovery-search__product-price');
            if (price && selected && Number(selected.compare_at_price) > Number(selected.price)) {
              price.replaceChildren(element('span', 'discovery-search__sale-price', money.format(Number(selected.price) / 100)),
                element('del', null, money.format(Number(selected.compare_at_price) / 100)));
            }
            if (selected && /^\d+$/.test(String(selected.id))) details.push({ card: card, variantId: String(selected.id) });
          } catch (_) { /* Extra card details must not block the results. */ }
        }
      }
      await Promise.all(Array.from({ length: Math.min(4, cards.length) }, worker));
      if (current !== requestNumber) return;
      ensureReviewsWidget().then(function () {
        if (typeof window.ratingSnippet !== 'function' || current !== requestNumber) return;
        window.ratingSnippet('ruk_rating_snippet', {
          store: window.reviewsIoStore || 'charterhouse-aquatics.myshopify.com', color: '#eab308',
          textClr: '#71717a', linebreak: false, usePolaris: true, text: 'Reviews', lang: 'en',
          mode: 'default', showEmptyStars: false
        });
      }).catch(function () { /* Ratings must not block browsing. */ });
      var ids = Array.from(new Set(details.map(function (entry) { return entry.variantId; })));
      if (!ids.length) return;
      var timer;
      try {
        var config = document.querySelector('[data-charterhouse-delivery-config]');
        var endpoint = config ? JSON.parse(config.textContent).endpoint : '/apps/charterhouse-delivery';
        if (typeof endpoint !== 'string' || !endpoint.startsWith('/') || endpoint.startsWith('//')) return;
        var controller = new AbortController();
        timer = setTimeout(function () { controller.abort(); }, 8000);
        var response = await fetch(endpoint, {
          method: 'POST', credentials: 'same-origin', signal: controller.signal,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ lines: ids.map(function (id) {
            return { variantId: 'gid://shopify/ProductVariant/' + id, quantity: 1 };
          }) })
        });
        if (!response.ok || current !== requestNumber) return;
        var data = await response.json();
        var estimates = new Map((data.estimates || []).map(function (item) { return [item.variantId, item]; }));
        var messages = data.messages && typeof data.messages === 'object' ? data.messages : {};
        details.forEach(function (entry) {
          if (!entry.card.isConnected || current !== requestNumber) return;
          var message = deliveryMessage(estimates.get('gid://shopify/ProductVariant/' + entry.variantId), messages);
          if (!message) return;
          var node = entry.card.querySelector('.discovery-search__delivery');
          node.textContent = message.text; node.dataset.tone = message.tone; node.hidden = false;
        });
      } catch (_) { /* Delivery availability must not block search. */ }
      finally { clearTimeout(timer); }
    }

    function renderBannerSlot(slot, banners) {
      var target = root.querySelector('[data-discovery-' + slot + ']');
      if (!target) return;
      target.replaceChildren();
      banners.filter(function (banner) { return banner.slot === slot; }).forEach(function (banner) {
        var node = bannerNode(banner, false);
        if (node) { target.appendChild(node); if (bannerSession) bannerSession.record(banner); }
      });
    }

    function renderPagination(total) {
      var pagination = page.parentElement;
      var pageCount = Math.ceil(total / pageSize);
      var currentPage = Math.floor(state.offset / pageSize) + 1;
      pagination.hidden = pageCount <= 1;
      page.replaceChildren();
      if (pageCount <= 1) return;
      var pages = new Set([1, pageCount]);
      for (var index = Math.max(1, currentPage - 1); index <= Math.min(pageCount, currentPage + 1); index++) pages.add(index);
      var last = 0;
      Array.from(pages).sort(function (a, b) { return a - b; }).forEach(function (number) {
        if (number - last > 1) page.appendChild(element('span', 'discovery-search__pagination-ellipsis', '…'));
        var button = element('button', 'discovery-search__page-number', number);
        button.type = 'button'; button.dataset.pageNumber = String(number);
        button.setAttribute('aria-label', 'Page ' + number);
        if (number === currentPage) button.setAttribute('aria-current', 'page');
        page.appendChild(button); last = number;
      });
    }

    function renderGridSkeleton() {
      grid.replaceChildren();
      grid.setAttribute('aria-busy', 'true');
      for (var index = 0; index < 6; index++) {
        var card = element('div', 'discovery-search__skeleton');
        card.setAttribute('aria-hidden', 'true');
        card.appendChild(element('span', 'discovery-search__skeleton-media'));
        card.appendChild(element('span', 'discovery-search__skeleton-title'));
        card.appendChild(element('span', 'discovery-search__skeleton-detail'));
        grid.appendChild(card);
      }
    }

    async function load() {
      var current = ++requestNumber;
      if (activeRequest) activeRequest.abort();
      if (!query) {
        count.textContent = 'Enter a search term to begin.';
        grid.replaceChildren(); return;
      }
      var controller = new AbortController();
      activeRequest = controller;
      var timeout = setTimeout(function () { controller.abort(); }, 20000);
      var url = new URL('/api/discovery/search', apiBase);
      url.searchParams.set('q', query); url.searchParams.set('tab', selectedTab);
      url.searchParams.set('limit', String(pageSize)); url.searchParams.set('offset', String(state.offset));
      if (selectedTab === 'products') ['vendor', 'productType', 'stock', 'tag', 'filterCollection', 'minPrice', 'maxPrice'].forEach(function (key) {
        if (state[key] !== '') url.searchParams.set(key, state[key]);
      });
      count.textContent = 'Loading results…'; message.hidden = true;
      if (selectedTab === 'products') renderGridSkeleton();
      try {
        var response = await fetch(url.href, { mode: 'cors', credentials: 'omit', signal: controller.signal });
        if (!response.ok) throw new Error('Discovery returned HTTP ' + response.status);
        var data = await response.json();
        if (current !== requestNumber) return;
        if (data.schemaVersion !== 1 || !Array.isArray(data.hits)) throw new Error('Unsupported Discovery response');
        if (selectedTab === 'products') recordSearchTerm(Number(data.tabs && data.tabs.products != null ? data.tabs.products : data.total));
        customSwatchColours = data.swatchColours && typeof data.swatchColours === 'object' && !Array.isArray(data.swatchColours)
          ? Object.assign(Object.create(null), data.swatchColours) : Object.create(null);
        tabs.forEach(function (tab) {
          root.querySelector('[data-discovery-tab-count="' + tab + '"]').textContent = String(data.tabs[tab] || 0);
        });
        renderFields(data.filterView);
        var banners = data.bannerView && Array.isArray(data.bannerView.items) ? data.bannerView.items : [];
        if (bannerSession) banners = bannerSession.select(banners);
        renderBannerSlot('hero', banners); renderBannerSlot('above-grid', banners); renderBannerSlot('empty-state', banners);
        renderHits(data.hits, selectedTab === 'products' ? banners : []);
        grid.removeAttribute('aria-busy');
        if (selectedTab === 'products') void hydrateProductCards(current);
        if (selectedTab === 'products' && data.hits.length) {
          var visibleIds = data.hits.map(function (hit) { return hit.shopifyId; }).filter(function (id) {
            return typeof id === 'string' && /^gid:\/\/shopify\/Product\/[1-9]\d*$/.test(id);
          });
          var impressionKey = JSON.stringify([query, state.offset, state.vendor, state.productType, state.stock,
            state.tag, state.filterCollection, state.minPrice, state.maxPrice, visibleIds]);
          if (visibleIds.length && !recordedImpressions.has(impressionKey)) {
            recordedImpressions.add(impressionKey);
            recordSearchProducts('impression', visibleIds);
          }
        }
        count.textContent = data.total + (data.total === 1 ? ' result' : ' results');
        clear.hidden = selectedTab !== 'products' || !['vendor', 'productType', 'stock', 'tag', 'filterCollection', 'minPrice', 'maxPrice'].some(function (key) { return state[key] !== ''; });
        previous.disabled = state.offset === 0; next.disabled = !data.page.hasMore;
        renderPagination(data.total);
        if (!data.total) {
          message.replaceChildren();
          message.appendChild(element('strong', null, 'No results found.'));
          var corrections = Array.isArray(data.suggestions) ? data.suggestions.filter(function (term) {
            return typeof term === 'string' && term.length > 0 && term.length <= 120;
          }).slice(0, 3) : [];
          if (corrections.length) {
            message.appendChild(element('span', null, 'Did you mean?'));
            var choices = element('span', 'discovery-search__corrections');
            corrections.forEach(function (term) {
              var link = element('a', null, term);
              var destination = new URL('/search', window.location.origin);
              destination.searchParams.set('q', term);
              destination.searchParams.set('view', 'discovery-preview');
              if (selectedTab !== 'products') destination.searchParams.set('tab', selectedTab);
              link.href = destination.pathname + destination.search;
              choices.appendChild(link);
            });
            message.appendChild(choices);
          } else message.appendChild(element('span', null, 'Try another search term or clear filters.'));
          message.hidden = false;
        }
      } catch (_) {
        if (current !== requestNumber) return;
        grid.replaceChildren(); grid.removeAttribute('aria-busy'); count.textContent = 'Results unavailable';
        message.textContent = 'We could not load the Discovery preview. Please try again later.'; message.hidden = false;
        previous.disabled = true; next.disabled = true; renderPagination(0);
      } finally {
        clearTimeout(timeout);
        if (activeRequest === controller) activeRequest = null;
      }
    }

    tabButtons.forEach(function (button, index) {
      button.addEventListener('click', function () { selectTab(button.dataset.discoveryTab); });
      button.addEventListener('keydown', function (event) {
        var targetIndex;
        if (event.key === 'ArrowRight') targetIndex = (index + 1) % tabButtons.length;
        else if (event.key === 'ArrowLeft') targetIndex = (index + tabButtons.length - 1) % tabButtons.length;
        else if (event.key === 'Home') targetIndex = 0;
        else if (event.key === 'End') targetIndex = tabButtons.length - 1;
        else return;
        event.preventDefault();
        tabButtons[targetIndex].focus();
      });
    });
    form.addEventListener('input', function (event) {
      var key = event.target.name;
      if (key !== 'minPrice' && key !== 'maxPrice') return;
      state[key] = event.target.value; clearTimeout(priceTimer); priceTimer = setTimeout(resetPage, 300);
    });
    form.addEventListener('change', function (event) {
      if (!event.target.name || !(event.target.name in state)) return;
      clearTimeout(priceTimer); state[event.target.name] = event.target.value; resetPage();
    });
    clear.addEventListener('click', function () {
      clearTimeout(priceTimer); state.vendor = ''; state.productType = ''; state.stock = ''; state.tag = ''; state.filterCollection = ''; state.minPrice = ''; state.maxPrice = ''; resetPage();
    });
    filterToggle.addEventListener('click', function () {
      filtersOpen = !filtersOpen;
      filterPanel.hidden = !filtersOpen;
      filterToggle.setAttribute('aria-expanded', filtersOpen ? 'true' : 'false');
    });
    previous.addEventListener('click', function () { state.offset = Math.max(0, state.offset - pageSize); load(); });
    next.addEventListener('click', function () { state.offset += pageSize; load(); });
    page.addEventListener('click', function (event) {
      var target = event.target.closest('[data-page-number]');
      if (!target || !page.contains(target)) return;
      var number = Number(target.dataset.pageNumber);
      if (!Number.isSafeInteger(number) || number < 1) return;
      state.offset = (number - 1) * pageSize;
      load();
    });
    grid.addEventListener('click', function (event) {
      var collectionLink = event.target.closest('a[data-discovery-collection-id]');
      if (collectionLink && grid.contains(collectionLink)) {
        var collectionId = collectionLink.dataset.discoveryCollectionId;
        if (!recordedCollectionOpens.has(collectionId)) {
          recordedCollectionOpens.add(collectionId);
          recordCollectionOpen(collectionId);
        }
      }
      var link = event.target.closest('a[data-discovery-product-id]');
      if (link && grid.contains(link)) {
        var productId = link.dataset.discoveryProductId;
        if (!recordedClicks.has(productId)) {
          recordedClicks.add(productId);
          recordSearchProducts('click', [productId]);
          recordSearchClick('product');
        }
      }
      var guideLink = event.target.closest('a[data-discovery-guide]');
      if (guideLink && grid.contains(guideLink)) recordSearchClick('guide');
    });
    selectTab(selectedTab);
  }

  function boot(container) { container.querySelectorAll('[data-discovery-search]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
